export default __webpack_public_path__ + "static/media/juice.3beaf434.png";